import { root, id } from './plan';

export const plan = {
  ...root,
  id,
};
